import { atom } from 'jotai';

export type PendingStartNow = {
  sessionId: string;
  parkedAt: number;
};

/** Parked until its session opens or its absolute deadline expires. */
export const pendingStartNowSessionIdAtom = atom<PendingStartNow | null>(null);
